// Libs
import { createSelector } from 'reselect'
import _size from 'lodash/size'
import _head from 'lodash/head'

// Selectors
import { environment$ } from 'fc-environment'
import seasons$ from 'fc-seasons/src/selectors/seasons'

// Utils
import sort from 'fc-seasons/src/utils/sort'

// Constants
import {
  PROP_HEFTY_SELECTED_SEASON,
} from 'fc-model-environment/src/constants'

export default createSelector(
  [
    environment$,
    seasons$,
  ],
  (environment, seasons) => {
    if (environment && environment[PROP_HEFTY_SELECTED_SEASON]) {
      return Number(environment[PROP_HEFTY_SELECTED_SEASON].value)
    }

    if (_size(seasons)) {
      const sortedSeasons = sort(seasons)
      const newestSeasonAdded = _head(sortedSeasons)
      if (newestSeasonAdded) {
        return newestSeasonAdded.id
      }
    }
    return null
  })
